import { render, staticRenderFns } from "./studioDialog.vue?vue&type=template&id=09f0fc9c&scoped=true"
import script from "./studioDialog.vue?vue&type=script&lang=js"
export * from "./studioDialog.vue?vue&type=script&lang=js"
import style0 from "./studioDialog.vue?vue&type=style&index=0&id=09f0fc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0fc9c",
  null
  
)

export default component.exports